import { Button, Modal, Popconfirm, Row, Switch, Table } from 'antd'
import React, { useState } from 'react'
import { CheckOutlined, CloseOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Button as BButton } from 'react-bootstrap';
import { useTicketGroups } from 'pages/store';
import AddInGroup from './AddInGroup';

const Group = ({ groupName, groupMembers }) => {
    const { putMemberActiveStatus, removeMemberFromGroup, deleteTicketGroup } = useTicketGroups();
    const [modalOpen, setModalOpen] = useState(false);
    const activeStatus = async (user, checked) => {
        putMemberActiveStatus({ user: user, status: checked });
    };
    const removeUser = (user) => {
        removeMemberFromGroup({ user: user, groupId: groupName });
    }
    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Active Status',
            dataIndex: 'activeStaus',
            key: 'activeStaus',
        },
        {
            title: 'Remove User',
            dataIndex: 'remove',
            key: 'remove',
        }
    ];

    const dataSource = groupMembers.map((user) => {
        return {
            key: user.user_id,
            name: user.first_name,
            email: user.email,
            activeStaus: <div className='text-center'>
                <Switch
                    checkedChildren={<CheckOutlined />}
                    unCheckedChildren={<CloseOutlined />}
                    defaultChecked={user.is_active}
                    onChange={(checked) => {
                        activeStatus(user, checked)
                    }}
                />
            </div>,
            remove: <Button type="primary" danger onClick={() => {
                removeUser(user);
            }}>
                Remove
            </Button>
        }
    })
    return (
        <div>
            <BButton type="primary" className='rounded' onClick={() => setModalOpen(true)}>
                <span className='p-2 fs-2'>
                    {groupName}
                </span>
            </BButton>
            <Modal
                title={groupName}
                destroyOnClose
                centered
                width={1000}
                open={modalOpen}
                footer={[<div className='d-flex gap-3 align-items-end justify-content-end'>
                    <Button key="back" onClick={() => setModalOpen(false)}>
                        Close
                    </Button>
                    <Popconfirm
                        title={`Delete the Group`}
                        icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                        description={`Are you sure to delete ${groupName} group?`}
                        onConfirm={() => {
                            deleteTicketGroup({ groupId: groupName, users: groupMembers });
                            setModalOpen(false);
                        }}
                        okText="Delete"
                        cancelText="Cancel"
                    >
                        <Button danger>Delete</Button>
                    </Popconfirm>
                    <AddInGroup groupMembers={groupMembers} groupName={groupName} />
                </div>
                ]}
                closeIcon={false}
            >
                <Table
                    columns={columns}
                    dataSource={dataSource}
                />
            </Modal>
        </div>
    )
}

export default Group